Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var formSaveAction = function (element, definition) {

        Vendd.inlineEdit.action.apply(this, [element, definition]);

    };
    formSaveAction.prototype = Object.create(Vendd.inlineEdit.action.prototype);
    formSaveAction.prototype.name = 'formSaveAction';

    formSaveAction.prototype.Enabled = function () {

        var self = this;

        var form = self.getForm();

        return form !== undefined
            && typeof form.hasChanges === 'function'
            && form.hasChanges();
    }

    formSaveAction.prototype.execute = function () {

        var self = this;

        if (!self.Enabled()) {

            return;

        }

        var form = self.getForm();

        if (form === undefined) {

            return;

        }

        form.save()
            .then(function () {

                Vendd.inlineEdit.uiLoader.show();

                window.location.href = LhApp.Function.Url.setParameterValueOnUrl(window.location.href, 'preview', 'true');
                
            });

    };

    Vendd.inlineEdit.formSaveAction = formSaveAction;

});